/* eslint-disable react/prop-types */
// Reusable availability legend (used under both admin & public calendars).

export default function AvailabilityLegend({ variant = "public" }) {
  return (
    <div
      className="mt-3 flex flex-wrap gap-x-5 gap-y-2 text-xs text-afb-ink/85"
      data-testid="availability-legend"
    >
      <span className="inline-flex items-center gap-2">
        <span className="w-4 h-4 rounded-sm bg-[#15803d] border border-[#15803d]" />
        Data disponibile
      </span>
      <span className="inline-flex items-center gap-2">
        <span className="w-4 h-4 rounded-sm bg-[#b91c1c] border border-[#b91c1c]" />
        Data non disponibile
      </span>
      <span className="inline-flex items-center gap-2">
        <span
          className={`w-4 h-4 rounded-sm border ${
            variant === "admin" ? "bg-[#b91c1c] border-[#b91c1c]" : "bg-[#4b5563] border-[#4b5563]"
          }`}
        />
        {variant === "admin" ? "Selezionata = bloccata" : "Data selezionata"}
      </span>
    </div>
  );
}
